module.exports = __webpack_public_path__ + "static/img/img04.6c81470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv029/img04.png
// module id = pWFt
// module chunks = 0